import React from 'react';
import '../components/css/popupstyle.css';
import $ from 'jquery';
import loader from '../../src/components/css/dark/img/loader.gif';

class ConfirmDeletePopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }
    componentDidMount() {

    }
    componentDidUpdate() {

    }

    HandleRadioButtonSelection = e => {
        this.props.HandleRadioButtonConfirmation(this.props.radioButtonValue);
    }

    HandleSearchTextSelection = e => {
        let fieldValue = [];
        fieldValue.push(this.props.SearchTextType);
        fieldValue.push(this.props.SearchTextValue);
        this.props.HandleSearchTextConfirmation(fieldValue);
    }

    render() {
        return (

            <div className='tool-section report confirmClose'>
                <div className='popup report-section claims'>
                    {
                        this.props.radioButtonSelection == true ?
                            <div className='popup_inner'>
                                <h1>Change Transaction Type <button onClick={this.props.closePopup}>X</button></h1>
                            <p>{this.props.titleText}</p>
                            {
                                <div className="pop-btn ungap">
                                        <button className="btn" onClick={this.HandleRadioButtonSelection}>Yes</button>
                                    <button className="btn cancel" onClick={this.props.closePopup}>No</button>
                                </div>
                                }
                            </div> : null
                    }
                    {
                        this.props.searchTextSelection == true ?
                            <div className='popup_inner'>
                                <h1>Change PCN <button onClick={this.props.closePopup}>X</button></h1>
                                <p>Adding this PCN is only available for Total Transactions. Your current Transaction Type selection will be updated to Total. Do you wish to continue?</p>
                                {
                                    <div className="pop-btn ungap">
                                        <button className="btn" onClick={this.HandleSearchTextSelection}>Yes</button>
                                        <button className="btn cancel" onClick={this.props.closePopup}>No</button>
                                    </div>
                                }
                            </div> : null
                    }
                </div>
            </div>

        )
    }
}

export default ConfirmDeletePopup;